import React from 'react';
import PropTypes from 'prop-types';
import {hasItem} from '../GlassTube.utils';
import {useGlassTubeTooltip} from './GlassTubeTooltip.utils';
import {ControlButtons, ControlTooltip} from '../../../ControlTooltip';

export function GlassTubeTooltip(props) {
  const {getButtonList} = useGlassTubeTooltip(props);

  const tooltipStyle = () => {
    if (hasItem(props.boxId)) {
      return {top: '-50px'};
    } else if (hasItem(props.stopperId)) {
      return {top: '-45px'};
    } else {
      return {top: '-30px'};
    }
  };

  const buttionList = getButtonList();
  if (props.showControls && buttionList.length) {
    return (
      <ControlTooltip showControls tooltipStyle={tooltipStyle()}>
        <ControlButtons buttonList={getButtonList()} />
      </ControlTooltip>
    );
  } else return null;
}

GlassTubeTooltip.propTypes = {
  /**
   * UniqueId for the stopper covering the tube
   */
  stopperId: PropTypes.number,
  /**
   * Boolean set to shwo control icons
   */
  showControls: PropTypes.bool,
  /**
   * Color value for the solution [ Empty means no solution]
   */
  solution: PropTypes.string,
  /**
   * UniqueId for the plant dropped in tube
   */
  plantId: PropTypes.number,
  /**
   * UniqueId for the snail dropped in tube
   */
  snailId: PropTypes.number,
  /**
   * UniqueId of the box covering the solution
   */
  boxId: PropTypes.number,
  /**
   * function to remove an Item
   */
  onRemoveItem: PropTypes.func,
};

GlassTubeTooltip.defaultProps = {
  showControls: false,
};
